const MINUTE_MS = 60 * 1000;

/**
 * How long until `resetTime`, as board 2.2 writes it: «14 ч 20 мин»,
 * «3 ч», «20 мин». Never less than a minute.
 */
export const formatResetIn = (resetTime: string, now = Date.now()) => {
  const minutesLeft = Math.max(
    1,
    Math.ceil((Date.parse(resetTime) - now) / MINUTE_MS),
  );
  const hours = Math.floor(minutesLeft / 60);
  const minutes = minutesLeft % 60;

  if (hours === 0) return `${minutes} мин`;

  return minutes === 0 ? `${hours} ч` : `${hours} ч ${minutes} мин`;
};
